const announcementTypes = {
	info: 'info',
	warning: 'warning',
	danger: 'critical',
	success: 'success',
};

export default announcementTypes;
